// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignment-search[data-v-3fa0747c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.assignment-search__search-field[data-v-3fa0747c] {\n  margin: 0 auto 20px;\n}\n.assignment-search__btn[data-v-3fa0747c] {\n  overflow: clip;\n  padding: 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
